import React, { useEffect } from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { APIURL } from './service/api-service';
import { APIResponseEntity } from './interface/api-responce';
import { IsStringNullEmptyOrUndefined } from './utils/null-check';
import { useMaintenanceStore } from './store/maintenance.store';
import { useUserActivity } from './hooks/useUserActivity';
import { getLocalStorageItem } from './service/storage-service';
import { StorageKeyEnum } from './utils/enum';
function App() {
  const { setUpdateStatus } = useMaintenanceStore()
  useUserActivity(!!getLocalStorageItem(StorageKeyEnum.JB_GLASS_AUTH_TOKEN));
  useEffect(() => {
    const checkVersion = async () => {
      try {
        if (APIURL) {
          // if (APIURL && process.env.NODE_ENV !== "development") {
          const response = await fetch(APIURL);
          const resp: APIResponseEntity = await response.json();

          if (resp && resp.status && resp.statusCode === 200) {
            console.log("Webapp Version: ", resp.data && resp.data.version);

            const version: string = resp.data && resp.data.version ? resp.data.version : "";

            const isShow = resp.data.isNotifyAllUser;
            const message = resp.data.messageForNotifyUser;
            setUpdateStatus(isShow, message);


            if (!IsStringNullEmptyOrUndefined(version) && version !== localStorage.getItem('appVersion')) {
              localStorage.setItem('appVersion', version);
              window.location.reload();
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch version:', error);
      }
    };

    const interval = setInterval(checkVersion, 20000); // Check every 20 seconds

    checkVersion(); // Initial check

    return () => clearInterval(interval);
  }, []);

  return (
    <ToastContainer />
  );
}

export default App;
